import { environmentBase } from './environmentBase';
export const environment = {
  message: 'Hello',
  production: false,
  Okta: {
    loginURL: '/login',
    appBaseHref: '/',
    oidc: {
      clientId: '0oaali6p3zFFKEBqk4x7',
      issuer: 'https://sso.gobeon.com/oauth2/default',
      redirectUri: 'https://dev.batchrater.gobeon.com/login/callback',
      end_session_redirect_uri: 'https://dev.batchrater.gobeon.com',
      idpEnabled: true,
      idpDiscoveryUrl:
        '/home/oidc_client/0oaali6p3zFFKEBqk4x7/aln177a159h7Zf52X0g8',
      scopes: ['openid', 'profile', 'email'],
    },
    widget: {
      useInteractionCodeFlow: false,
      UseClassicEngine: true,
    },
  },
  Settings: {
    WEB_TARGET_API: 'https://api.dev.batchrater.gobeon.com/BeonRater/',
    subscription_key: 'cbaf55b380314897b437b8957171ee68',
  },
};
